import { Menu, MenuItem } from 'react-bootstrap-typeahead';
import React from 'react';

interface CreateRenderMenuProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  // CORRECCIÓN: Permitimos que el ref contenga null (HTMLInputElement | null)
  searchInputRef: React.RefObject<HTMLInputElement | null>;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
}

export const createRenderMenuWithSearch = ({
  searchQuery,
  setSearchQuery,
  searchInputRef,
  options,
  placeholder = 'Buscar...'
}: CreateRenderMenuProps) => {
  
  // Filtrar opciones según búsqueda
  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (results: any[], menuProps: any) => {

    const {
      newSelectionPrefix,
      paginationText,
      renderMenuItemChildren,
      ...validMenuProps 
    } = menuProps;

    return (
      <Menu {...validMenuProps} className="custom-typeahead-menu">
        {/* Input de búsqueda dentro del menú */}
        <div className="typeahead-search-box">
          <input
            // Casteamos a RefObject<HTMLInputElement> para satisfacer al input de React
            // ya que sabemos que cuando se renderice, esto será un input válido.
            ref={searchInputRef as React.RefObject<HTMLInputElement>}
            type="text"
            className="form-control form-control-sm"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onMouseDown={(e) => {
              // Prevenir que el menú se cierre al hacer clic
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              // Prevenir que Typeahead capture las teclas
              e.stopPropagation();
            }}
            autoFocus
          />
        </div>

        {/* Lista de opciones filtradas */}
        <div className="typeahead-options-list">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <MenuItem key={option.value} option={option} position={index}>
                {option.label}
              </MenuItem>
            ))
          ) : (
            <div className="typeahead-no-results">
              No se encontraron resultados
            </div>
          )}
        </div>
      </Menu>
    );
  };
};

export const createMenuToggleHandler = (
  // CORRECCIÓN: Aquí también permitimos null
  searchInputRef: React.RefObject<HTMLInputElement | null>,
  setSearchQuery: (query: string) => void
) => {
  return (isOpen: boolean) => {
    if (isOpen) {
      // Enfocar el input de búsqueda cuando se abre el menú
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 50);
    } else {
      // Limpiar búsqueda al cerrar
      setSearchQuery('');
    }
  };
};